import { ArrowRightIcon, Button, CloseIcon } from "@datagame/ui";
import { useTranslation } from "react-i18next";

import { useStep } from "../../../../../../../contexts/step/StepContext";

import styles from "./ActionButtons.module.scss";

export const ActionButtons = () => {
  const { t } = useTranslation();
  const { currentStep, setCurrentStep } = useStep();

  return (
    <div className={styles.buttons}>
      <Button
        iconSide="left"
        icon={<ArrowRightIcon />}
        onClick={() => setCurrentStep(currentStep + 1)}
        className={styles.nextButton}
      >
        {t("project:navigation.controls.next")}
      </Button>
      <Button kind="outline" iconSide="left" icon={<CloseIcon />} onClick={() => setCurrentStep(currentStep - 1)}>
        {t("project:navigation.controls.back")}
      </Button>
    </div>
  );
};
